import React from 'react';
import AutoSuggest from "@Features/autosuggest/components/AutoSuggest";
import FormSuggestion from "@Form/features/stations/components/FormSuggestion";

function MultiSelectFieldStations(props) {
    const {
        placeholder,
        autoSuggestModel,
        visible,
        children,
    } = props

    if (!visible.value) {
        return (
            <div
                id="stationSelect"
                className="gb--input-standalone"
                onClick={visible.onChange}
            >
                {children.length ? (
                    children
                ) : (
                    <span className="gb--placeholder">{placeholder}</span>
                )}
            </div>
        )
    }

    return (
        <AutoSuggest
            placeholder={placeholder}
            autoSuggestModel={autoSuggestModel}
            suggestionComponent={<FormSuggestion/>}
            additionalInputClassName="gb--input-standalone ui-autocomplete-input"
            autoFocus
        />
    )
}

export default MultiSelectFieldStations;